import * as t from "io-ts";
import { stringLiteral } from "./const-array";
export const trailerTypeT = t.union([
    t.literal("FRIGO"),
    t.literal("CURTAIN_SIDE"),
    t.literal("BOX"),
    t.literal("FLATBED"),
    t.literal("AUTO_TRAILER"),
    t.literal("BULK"),
    t.literal("ANIMAL_TRANSPORT"),
    t.literal("CONCRETE_CANNON"),
    t.literal("CONTAINER_CHASSIS"),
    t.literal("CONTAINER"),
    t.literal("SEMI_TRUCK"),
    t.literal("RIGID_HGV"),
    t.literal("JUMBO"),
    t.literal("MEGA"),
    t.literal("VAN"),
    t.literal("TANKER"),
    t.literal("THERMO"),
    t.literal("DUMPERLOAD"),
    t.literal("RIGID_HGV_TRAILER"),
    t.literal("BLOCK_WAGON"),
    t.literal("OTHER"),
    t.literal("OTHER_POWERED"),
    t.literal("WALKING_FLOOR"),
]);
export const cargoTypes = [
    "MISCELLANEOUS",
    "PALLET_GOODS",
    "GENERAL_CARGO",
    "COOL",
    "FREEZE",
    "CC",
    "BULK_CARGO",
    "CONCRETE",
    "PHARMA",
    "PACKAGES",
    "20_FEET",
    "20_FEET_HIGH_CUBE",
    "40_FEET",
    "40_FEET_HIGH_CUBE",
    "MACHINES",
    "CARS",
    "BOATS",
    "LIVE_ANIMALS",
    "COIL",
    "CONTAINER",
    "SLUDGE",
    "MODULE",
    "LIQUID",
    "CRANE_WORK",
    "4_AXLE_RIGID_HGV",
    "4_AXLE_CRANE",
    "7_AXLE_CENTRE_TRAILER",
    "7_AXLE_TRAILER",
    "7_AXLE_CRANE",
    "3_AXLE_TRUCK",
    "5_AXLE_TIPPER_TRAILER",
    "7_AXLE_TIPPER_TRAILER",
    "BIG_BAGS",
    "WAREHOUSE",
    "WORKSHOP",
    "SERVICE_VAN",
    "FLANGERS",
    "LOW_BED_TRAILER",
    "STRAIGHT_EXTENDABLE_TRAILER",
    "WASTE",
    "SERVICE",
    "DELIVERY",
    "COLLECTION",
    "8_FEET",
    "10_FEET",
    "DANGEROUS_CARGO",
    "GMP+",
    "SLURRY",
];
export const cargoQualityValues = [
    "ADR",
    "A_SIGN",
    "WIDE_CARGO",
    "MOVING_GOODS",
    "HIGH_GOODS",
    "LONG_GOODS",
    "FURNITURE",
    "SPIRITS",
    "STRAPS",
    "SPECIAL_TRANSPORT",
    "CUSTOMS",
    "TROPHIES",
    "WOOD_ACTIVATORS",
    "T1_GOODS",
];
export const trailerQualityValues = [
    "SIDE_OPEN",
    "WALKING_FLOOR",
    "LIFT",
    "HOOK",
    "PALLET_LIFTER",
    "FORKLIFT",
    "RAISED_ROOF",
    "CRANE",
    "HOOK_HOIST",
    "BACK_TIP",
    "STEP_DECK",
    "RAMPS",
    "SIDE_TIP",
    "PARTITION",
    "SLIDING_ROOF",
    "FLATBED",
    "PALLET_FORKS",
    "LIFTING_BEAM",
    "WINCH",
    "GLASS_SUCTION_LIFTER",
    "BOAT_TRAILER",
    "EXTENDABLE_TRAILER",
    "EYE_BOLTS",
    "DEHA_LIFTING_ANCHORS",
    "CABLE_LIFT_SYSTEM",
    "GRAB",
    "OPEN_TOP_TRAILER",
    "BOX_TRAILER",
    "INSPECTION",
];
export const cargoQualityT = stringLiteral(cargoQualityValues, "cargo quality");
export const trailerQualityT = stringLiteral(trailerQualityValues, "trailer quality");
export const cargoTypeT = stringLiteral(cargoTypes, "cargo type");
export const vehicleCo2EmissionsClassT = t.union([
    t.literal("CLASS 1"),
    t.literal("CLASS 2"),
    t.literal("CLASS 3"),
    t.literal("CLASS 4"),
    t.literal("CLASS 5"),
]);
export const vehicleTypeT = t.union([
    t.literal("EURO 1"),
    t.literal("EURO 2"),
    t.literal("EURO 3"),
    t.literal("EURO 4"),
    t.literal("EURO 5"),
    t.literal("EURO 6"),
    t.literal("Electric"),
    t.literal("Hydrogen"),
    t.literal("Gas"),
]);
export const fuelTypeT = t.union([
    t.literal("DIESEL"),
    t.literal("CNG"),
    t.literal("LNG"),
    t.literal("BEV"),
]);
export const trailerTypes = [
    "FRIGO",
    "CURTAIN_SIDE",
    "BOX",
    "FLATBED",
    "AUTO_TRAILER",
    "BULK",
    "ANIMAL_TRANSPORT",
    "CONCRETE_CANNON",
    "CONTAINER_CHASSIS",
    "CONTAINER",
    "SEMI_TRUCK",
    "RIGID_HGV",
    "JUMBO",
    "MEGA",
    "VAN",
    "TANKER",
    "THERMO",
    "DUMPERLOAD",
    "RIGID_HGV_TRAILER",
    "BLOCK_WAGON",
    "OTHER",
    "OTHER_POWERED",
];
export const cargoInvoiceStatusValues = [
    "OPEN",
    "READY_FOR_INVOICE",
    "INVOICED",
    "NO_PAYMENT",
    "CARD_CASH",
];
export const cargoInvoiceStatusT = stringLiteral(cargoInvoiceStatusValues, "cargo invoice status");
//# sourceMappingURL=types.js.map